import { createCrudStore } from "@/store/crudStore";
import { apiService } from "@/services/api";

// ============ BALANCEADO CAMPO ============
const balanceadoCampoStore = createCrudStore("balanceados");

const balanceadoCampo = {
  ...balanceadoCampoStore,

  getters: {
    ...balanceadoCampoStore.getters,
    balanceadosCampo(state) {
      return state.balanceados || [];
    },
  },

  actions: {
    ...balanceadoCampoStore.actions,

    // ✅ Sobrescribir getAllStates para usar ruta custom
    async getAllStates({ dispatch }) {
      return dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.getCustom("balanceados/balanceado_campo/"),
        onSuccessCallback: (commit, data) => commit("setState", data),
        errorMessage: "Error obteniendo balanceados de campo",
      });
    },

    async getBalanceadosCampo({ dispatch }) {
      return dispatch("getAllStates");
    },

    // ✅ create usa apiService.create("balanceados", payload) → POST /balanceados/ ✓

    postBalanceadoCampo: balanceadoCampoStore.actions.create,
    patchBalanceadoCampo: balanceadoCampoStore.actions.update,
    deleteBalanceadoCampo: balanceadoCampoStore.actions.delete,

    async patchBalanceadoCampoStock({ dispatch }, { id, delta }) {
      return dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.patchCustom(
            `balanceados/balanceado_campo/${id}/stock?delta=${delta}`,
            {}
          ),
        onSuccessCallback: (commit, data) => commit("updateItem", data),
        errorMessage: "Error actualizando stock de campo",
      });
    },
  },
};

// ============ BALANCEADO COMPRA ============
const balanceadoCompraStore = createCrudStore("balanceado_compra");

const balanceadoCompra = {
  ...balanceadoCompraStore,

  getters: {
    ...balanceadoCompraStore.getters,
    balanceadosCompra(state) {
      return state.balanceado_compra || [];
    },
  },

  actions: {
    ...balanceadoCompraStore.actions,

    // ✅ GET /balanceados/balanceado_compra/
    async getAllStates({ dispatch }) {
      return dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.getCustom("balanceados/balanceado_compra/"),
        onSuccessCallback: (commit, data) => commit("setState", data),
        errorMessage: "Error obteniendo balanceados de compra",
      });
    },

    // ✅ POST /balanceados/balanceado_compra/
    async create({ dispatch }, payload) {
      return dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.postCustom("balanceados/balanceado_compra/", payload),
        onSuccessCallback: (commit, data) => commit("addItem", data),
        errorMessage: "Error creando balanceado de compra",
      });
    },

    // ✅ PUT /balanceados/balanceado_compra/{id}
    async update({ dispatch }, payload) {
      return dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.patchCustom(
            `balanceados/balanceado_compra/${payload.id}`,
            payload
          ),
        onSuccessCallback: (commit, data) => commit("updateItem", data),
        errorMessage: "Error actualizando balanceado de compra",
      });
    },

    async getBalanceadosCompra({ dispatch }) {
      return dispatch("getAllStates");
    },

    async postBalanceadoCompra({ dispatch }, payload) {
      return dispatch("create", payload);
    },

    async patchBalanceadoCompra({ dispatch }, payload) {
      return dispatch("update", payload);
    },

    // ✅ PATCH /balanceados/balanceado_compra/{id}/stock
    async patchBalanceadoCompraStock({ dispatch }, { id, delta }) {
      return dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.patchCustom(
            `balanceados/balanceado_compra/${id}/stock?delta=${delta}`,
            {}
          ),
        onSuccessCallback: (commit, data) => commit("updateItem", data),
        errorMessage: "Error actualizando stock de compra",
      });
    },

    // ✅ DELETE /balanceados/balanceado_compra/{id}
    async deleteBalanceadoCompra({ dispatch }, id) {
      return dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.deleteCustom(`balanceados/balanceado_compra/${id}`),
        onSuccessCallback: (commit) => commit("removeItem", id),
        errorMessage: "Error eliminando balanceado de compra",
      });
    },
  },
};

// ============ EXPORT ============
export default {
  balanceadoCampo,
  balanceadoCompra,
};
